import React from 'react';
import Translate from './Translate';

const OptionalServiceSelected = () => (
  <div className="service__optional-marker">
    <Translate content="Optional" />
  </div>
);

export default OptionalServiceSelected;
